import { API_ENDPOINTS } from "../../constant/_constant";
import { useEffect, useState } from "react";
import { Button, Form, Row, Col } from "react-bootstrap";
import usePostRequest from "../../hooks/usePostRequest";
import RoleCard from "./RoleCard";
import Card from "react-bootstrap/Card";
import { toast } from "react-toastify";
import Skeleton from "../../components/Skeleton";
import { useSelector } from "react-redux";
import Select from "react-select";
import useIdleLogout from "../../hooks/useIdleLogout";

const RoleListing = () => {
  const [formData, setFormData] = useState({
    id: null,
    name: "",
    description: "",
    color: "#e02e2e",
    department_email: "",
    department_head_ids: [],
  });

  const {
    data,
    isLoading,
    postData: fetchRoles,
  } = usePostRequest(API_ENDPOINTS.GET_ROLES);

  const { isLoading: createLoading, postData: createRole } = usePostRequest(
    API_ENDPOINTS.POST_ROLES
  );

  const { postData: fetchUsers, data: users } = usePostRequest(
    API_ENDPOINTS.GET_USERS
  );

  useIdleLogout();

  const handleEditRole = (role) => {
    const {
      id,
      name,
      description,
      department_email,
      department_heads = [],
    } = role;
    setFormData({
      id,
      name,
      description,
      department_email,
      //  department_head
      department_head_ids: department_heads.map((head) => head.id),
    });
  };

  const handleCancel = () => {
    setFormData({
      id: null,
      name: "",
      description: "",
      color: "#e02e2e",
      department_email: "",
      department_head_ids: "",
    });
  };

  useEffect(() => {
    fetchUsers({
      limit: "100",
    })
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;

    // Only allow letters and hyphens
    if (name === "name") {
      const regex = /^[a-zA-Z-]*$/;
      if (!regex.test(value)) {
        return;
      }
    }

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const onSuccess = () => {
    toast.success("Department updated successfully");
    handleCancel();
    fetchRoles();
    fetchUsers();
  };

  const onError = (error) => {
    toast.error(error?.message);
  };

  const handleUpdateRole = () => {
    const payload = {
      role_id: formData?.id,
      name: formData?.name,
      description: formData?.description,
      color: formData?.color,
      department_email: formData?.department_email,
      department_head_ids: formData?.department_head_ids,
    };
    createRole(payload, onSuccess, onError, API_ENDPOINTS.UPDATE_ROLE);
  };

  const handleCreateRole = (e) => {
    e.preventDefault();

    if (formData?.id) {
      handleUpdateRole();
      return;
    }
    const payload = {
      name: formData?.name,
      description: formData?.description,
      color: formData?.color,
      department_email: formData?.department_email,
      department_head_ids: formData?.department_head_ids,
    };
    createRole(payload, onSuccess, onError);
  };

  const user = useSelector((state) => state.auth.user);
  // check perminssion
  const userPermissions = user?.permissions?.manage_role || [];
  const hasPermission = (permissionArray, permissionType) =>
    permissionArray.includes(permissionType);
  const canDeleteRole = hasPermission(userPermissions, "delete");
  const canWriteRole = hasPermission(userPermissions, "write");
  const canAssignRole = canWriteRole;
  // check perminssion

  useEffect(() => {
    fetchRoles();
  }, []);

  return (
    <>
      <div className="page-header d-print-none">
        <div className="row g-2 align-items-center">
          <div className="col">
            <h2 className="page-title">Department</h2>
          </div>
        </div>
      </div>

      {canWriteRole && (
        <Card>
          <Card.Body>
            <Form onSubmit={handleCreateRole} autoComplete="off">
              <Row>
                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label className="form-label required">
                      Department Name
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Name"
                      required
                      name="name"
                      value={formData?.name}
                      onChange={handleChange}
                      disabled={formData?.id && formData?.name === "superadmin"}
                    />
                    <Form.Text>
                      Department name can only include letters and hyphens (-).
                    </Form.Text>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label className="form-label ">
                      Department Email
                    </Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Enter Email"
                      name="department_email"
                      value={formData?.department_email}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                {/* <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label className="form-label ">
                      Department Head
                    </Form.Label>
                    <Form.Select
                      name="department_head"
                      required
                      value={formData?.department_head}
                      onChange={handleChange}
                    >
                      <option value="">Select Department Head</option>
                      {users?.data?.map((user) => (
                        <option key={user.username} value={user.username}>
                          {user.first_name} {user.last_name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col> */}

                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label className="form-label">
                      Department Head(s)
                    </Form.Label>
                    <Select
                      isMulti
                      name="department_head_ids"
                      options={
                        users?.data?.map((user) => ({
                          label: `${user.first_name} ${user.last_name}`,
                          value: user.id, // 🔥 Send ID, not username
                        })) || []
                      }
                      value={
                        Array.isArray(formData?.department_head_ids)
                          ? formData?.department_head_ids.map((id) => {
                              const user = users?.data?.find(
                                (u) => u.id === id
                              );
                              return {
                                label: `${user?.first_name || ""} ${
                                  user?.last_name || ""
                                }`,
                                value: id,
                              };
                            })
                          : []
                      }
                      onChange={(selectedOptions) =>
                        setFormData((prev) => ({
                          ...prev,
                          department_head_ids: selectedOptions.map(
                            (opt) => opt.value
                          ), // 🔥 Store array of IDs
                        }))
                      }
                      className="basic-multi-select"
                      classNamePrefix="select"
                    />
                  </Form.Group>
                </Col>

                <Col md={2}>
                  <Form.Group className="mb-3">
                    <Form.Label>Choose Color</Form.Label>
                    <Form.Control
                      type="color"
                      // required
                      name="color"
                      value={formData?.color}
                      onChange={handleChange}
                      style={{ height: "40px" }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Form.Group className="mb-3">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  required
                  placeholder="Description"
                  name="description"
                  value={formData?.description}
                  onChange={handleChange}
                  style={{ height: "100px" }}
                />
              </Form.Group>

              <Button
                variant="primary"
                type="submit"
                className="btn btn-theme me-2"
                disabled={createLoading}
              >
                {createLoading
                  ? "Loading..."
                  : formData?.id
                  ? "Update Department"
                  : "Create Department"}
              </Button>
              <Button variant="outline-secondary" onClick={handleCancel}>
                Cancel
              </Button>
            </Form>
          </Card.Body>
        </Card>
      )}

      <div className="row mt-4">
        {isLoading ? (
          <Skeleton rows={5} columns={3} />
        ) : (
          data?.data?.map((role) => (
            <RoleCard
              key={role?.id}
              role={role}
              handleEditRole={handleEditRole}
            />
          ))
        )}
      </div>
    </>
  );
};

export default RoleListing;
